import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { isUndefined } from 'util';
import { SkypeService } from '../skype.service';
import { AllService } from '../../../services/all.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sign-skype',
  templateUrl: './sign-skype.component.html',
  styleUrls: ['./sign-skype.component.css']
})
export class SignSkypeComponent implements OnInit {
  Form: UntypedFormGroup;
  arCode: any = {};
  constructor(private router: Router, public allService: AllService, private skypeService: SkypeService) {}
  ngOnInit() {
    this.initForms();
  }
  initForms() {
    this.Form = new UntypedFormGroup({
      login: new UntypedFormControl({ value: 'Claver777', disabled: true }, Validators.required),
      password: new UntypedFormControl({ value: 'Claver18', disabled: true }, Validators.required)
    });
  }
  onSubmit() {
    const controls = this.Form.controls;
    const values = this.Form.value;

    // Проверяем форму на валидность */
    if (this.Form.invalid) {
      // Если форма не валидна, помечаем все контролы как touched **/
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      return;
    }
    this.skypeService.auth(values.login, values.password).subscribe(
      (result: any) => {
        if (isUndefined(result.error_msg)) {
          this.goPage();
        } else {
          alert(result.error_msg);
        }
      },
      (error) => {
        this.skypeService.errorHandling(error);
      }
    );
  }
  goPage(): void {
    //this.router.navigate([`/${this.skypeService.type}/`]);
  }
}
